export default class FirebaseServiceMock {
  public async googleLogin() {
    return Promise.resolve()
  }
}
